import React from "react";
import "../../src/App.css";

function AboutUs() {
  return (
    <div className="page-content">
      <h1>About Us</h1>
      <p>
        multido.com is a task management application designed to help you stay
        organized and productive. Whether you’re managing daily tasks, tracking
        deadlines, or keeping a list of books to read, we’ve got you covered.
      </p>
      <h2>Our Mission</h2>
      <p>
        We aim to empower users to achieve their goals by providing a simple,
        intuitive, and powerful tool for task management. Our focus is on
        usability, accessibility, and continuous improvement based on user
        feedback.
      </p>
      <h2>Our Team</h2>
      <p>
        We’re a small team of developers and designers passionate about
        productivity tools. Based in [Your Location], we’re dedicated to making
        multido.com the best it can be.
      </p>
      <h2>Contact Us</h2>
      <p>
        Have questions or suggestions? Reach out to us at{" "}
        <a href="mailto:info@multido.com">info@multido.com</a>.
      </p>
    </div>
  );
}

export default AboutUs;
